<template>
  <appointment-complete
    main-page-title="Manejo de Citas"
    :main-page-routes="[
      'Inicio',
      'Estudiante',
      'Citas',
      'Manejo de Citas',
      'Completar Cita'
    ]"
    :get-appointment-info="getAppointmentInfo"
    :get-specialist-practitioners="getSpecialistPractitioners"
    :get-appointment-municipalities="getMunicipalities"
    :get-appointment-locations="getAppointmentLocations"
    :get-specialist-by-location="getSpecialistByLocation"
    :complete-appointment="completeAppointment"
    :get-frequency-type="getFrequencyType"
    :get-service-modalities="getServiceModalities"
    :get-therapy-durations="getTherapyDurations"
    :get-appointment-therpies="getAppointmentTherpies"
    :get-services="getServices"
    :getReevaluationTimes="getReevaluationTimes"
  />
</template>

<script>
import { AppointmentComplete } from "appointment-management";

import appointmentServiceManager from "@/services/api/appointment.api.js";
import codeServiceManager from "@/modules/common/code.api.js";
export default {
  name: "AppointmentCompleteWrapper",
  components: {
    AppointmentComplete
  },
  methods: {
    getAppointmentInfo(id) {
      return appointmentServiceManager.getAppointmentInfo(id);
    },
    getSpecialistPractitioners(disciplineTypeCod, specialistLocationId) {
      return appointmentServiceManager.getSpecialistPractitioners(
        disciplineTypeCod,
        specialistLocationId
      );
    },
    getMunicipalities(_, companyId) {
      return appointmentServiceManager.getMunicipalities(companyId);
    },
    getAppointmentLocations(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationAddressMunicipalityId
    ) {
      return appointmentServiceManager.getAppointmentLocations(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationAddressMunicipalityId
      );
    },
    getSpecialistByLocation(
      fiscalYearId,
      companyId,
      disciplineTypeCod,
      serviceTypeCode,
      locationFiscalYearId
    ) {
      return appointmentServiceManager.getSpecialistByLocation(
        fiscalYearId,
        companyId,
        disciplineTypeCod,
        serviceTypeCode,
        locationFiscalYearId
      );
    },
    async completeAppointment(params) {
      const {
        data: response
      } = await appointmentServiceManager.completeAppointment(params);

      return await appointmentServiceManager.saveStudentEvaluationDocumentRelationship(
        response
      );
    },
    //intervention recomendation service handlers
    getAppointmentTherpies(id) {
      return appointmentServiceManager.getAppointmentTherpies(id);
    },
    getServices(serviceTypeIds, categories) {
      return appointmentServiceManager.getServices(serviceTypeIds, categories);
    },
    getFrequencyType() {
      return codeServiceManager.getFrequencyType();
    },
    getServiceModalities(disciplineTypeId) {
      let payload = {
        Screen: "AppointmentComplete",
        DisciplineTypeId: null
      };

      if (disciplineTypeId !== undefined && disciplineTypeId > 0) {
        payload.DisciplineTypeId = disciplineTypeId;
      }
      return codeServiceManager.getServiceModalities(payload);
    },
    getTherapyDurations() {
      return codeServiceManager.getTherapyDurations();
    },
    getReevaluationTimes() {
      return codeServiceManager.getReevaluationTimes();
    }
  }
};
</script>
